import { apolloClient } from "@/plugins/vue-apollo.js";

const createPropertyType = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/property/api/mutations/propertyType/create_property_type.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/property/api/queries/propertyType/property_type_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allPropertyType = store.readQuery(query);
        allPropertyType.getPropertyTypes.PropertyTypes.unshift(data.createPropertyType); //push to top
        store.writeQuery({
          ...query,
            data: allPropertyType,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createPropertyType };
